var context = {
    context: "app"
};

context.init = function() {
    $("body").attr("data-app-mode", context.context);
}